import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useToolCardById } from '@backrs_ui/grow-ui/src/pages/Home/hooks/stickerCardMapping';
import {
  FEATURE_FLAGS,
  selectIsFeatureFlagEnabled,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';

import { ActionStickerCardSection, ToolsSectionParams } from './useGetToolsPageSections';

const GREAT_COLLEGE_STRINGS = appStrings.modules.home.sections.getBackedYourWay.greatCollege;
const SCORE_JOB_INTERNSHIP_STRINGS =
  appStrings.modules.home.sections.getBackedYourWay.scoreJobInternship;

export const TOOLS_COLLEGE_SECTION = ({
  navigate,
}: ToolsSectionParams): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });
  const isTestBoosterEnabled = useAppSelector(
    selectIsFeatureFlagEnabled(FEATURE_FLAGS.TEST_BOOSTER),
  );

  return {
    title: GREAT_COLLEGE_STRINGS.title,
    description: GREAT_COLLEGE_STRINGS.description,
    actionStickerCards: [
      ...(isTestBoosterEnabled ? [getStickerCard('sat_act_booster')] : []),
      getStickerCard('college_shortlist'),
      getStickerCard('resume_builder'),
      getStickerCard('lower_cost_of_college'),
      getStickerCard('essay_ideas'),
      getStickerCard('majors'),
      getStickerCard('improve_test_scores'),
      getStickerCard('what_are_your_chances'),
      getStickerCard('compare_colleges'),
    ],
  };
};

export const TOOLS_SCORE_JOB_INTERNSHIP_SECTION = ({
  navigate,
}: ToolsSectionParams): ActionStickerCardSection => {
  const { getStickerCard } = useToolCardById({ navigate });

  return {
    title: SCORE_JOB_INTERNSHIP_STRINGS.title,
    description: SCORE_JOB_INTERNSHIP_STRINGS.description,
    actionStickerCards: [
      getStickerCard('jobs_you_might_love'),
      getStickerCard('boost_odds_of_an_offer'),
      getStickerCard('resume_optimizer'),
      getStickerCard('boost_your_profile'),
    ],
  };
};
